module.exports = __webpack_public_path__ + "media/images/select@2x-b2e78a1bb2ab041b365a009ed9db52c3.png";